import firebase from 'firebase/app';
import 'firebase/auth';
import * as firebaseui from 'firebaseui';
import { user } from './store';
import { apiGet } from './httpCommon';

const firebaseConfig = {
  apiKey: 'AIzaSyCAiGgZAnfapNB6MM84fLNLCUBEjJWDgHg',
  authDomain: 'fd-popup-search.firebaseapp.com',
  databaseURL: 'https://fd-popup-search.firebaseio.com',
  projectId: 'fd-popup-search',
  storageBucket: 'fd-popup-search.appspot.com',
  messagingSenderId: '905037276994',
  appId: '1:905037276994:web:5b8a01d418f43b9ab3cadb',
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const providers = [
  //new firebase.auth.GoogleAuthProvider(),
  // Email auth page required....
  //new firebase.auth.EmailAuthProvider()
];
export const authUI = new firebaseui.auth.AuthUI(auth);

async function setUser(firebaseUser) {
  if (firebaseUser) {
    const token = await auth.currentUser.getIdToken();
    try {
      const resp = await apiGet('customer/session-login', { token });
      user.set({
        loggedIn: true,
        uid: firebaseUser.uid,
        email: firebaseUser.email,
        name: firebaseUser.displayName,
        emailVerified: firebaseUser.emailVerified,
        token: resp.token,
      });
    } catch (err) {
      console.error('Failed to get session', err);
      auth.signOut();
    }
  } else {
    user.set({ loggedIn: false });
  }
}

auth.onAuthStateChanged(setUser);

setUser(auth.currentUser);

export async function getAuthToken() {
  if (auth.currentUser) {
    return await auth.currentUser.getIdToken();
  }
}
